import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const GOLD = '#d8b878';
const BONUS_MOCKUP = 'https://cdn.magicpatterns.com/uploads/awEfVPPAVCP6affPqhbc9L/mockup-bono-despierta-el-juego.webp';
const EXERCISES = ['Los ciclos que se repiten', 'Las reglas que nunca elegí', 'Mi personaje aprendido', 'Mi conciencia observadora', 'El miedo como guardián', 'Relaciones como espejo', 'Mi tablero actual', 'Mi nueva forma de jugar', 'Declaración personal'];
export function BonusWorkbook() {
  const scrollToPrecio = (e: React.MouseEvent) => {
    e.preventDefault();
    const el = document.getElementById('precio');
    if (el) {
      el.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <section className="relative overflow-hidden bg-matrix-black py-20 md:py-28 px-5 md:px-8" data-id="element-35">
      {/* Subtle digital texture + depth */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.04]" style={{
      backgroundImage: 'repeating-linear-gradient(90deg, rgba(0,255,65,0.6) 0px, rgba(0,255,65,0.6) 1px, transparent 1px, transparent 10px)',
      maskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)'
    }} data-id="element-36"></div>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(216,184,120,0.07)_0%,_transparent_55%)]" data-id="element-37"></div>
      <div className="pointer-events-none absolute left-0 top-1/2 z-0 h-[70vh] w-[55vh] -translate-y-1/2 -translate-x-1/4 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.10)_0%,_rgba(0,255,65,0.04)_45%,_transparent_72%)] blur-3xl" data-id="element-38"></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-39"></div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-40">
        {/* Left — workbook mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1
      }} className="order-1 flex-shrink-0 flex justify-center" data-id="element-41">
          <div className="relative" data-id="element-42">
            <div className="absolute -inset-6 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.18)_0%,_rgba(0,255,65,0.08)_45%,_transparent_72%)] blur-2xl" data-id="element-43"></div>
            <motion.img src={BONUS_MOCKUP} alt="Bono: Cuaderno de Reflexión — Despierta el Juego" loading="lazy" className="relative z-10 w-56 sm:w-64 md:w-72 lg:w-80 rounded-xl border border-[rgba(216,184,120,0.3)] shadow-[0_30px_70px_-20px_rgba(0,0,0,0.95),0_0_50px_rgba(216,184,120,0.22)]" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-44" />
          </div>
        </motion.div>

        {/* Right — text + exercises */}
        <motion.div initial={{
        opacity: 0,
        x: 40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="order-2 flex-1" data-id="element-45">
          <span className="inline-flex items-center gap-2 font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-5" style={{
          color: 'rgba(216,184,120,0.8)'
        }} data-id="element-46">
            <GiftIcon size={13} strokeWidth={1.6} data-id="element-47" />
            Bono especial incluido
          </span>
          <h2 className="font-cinzel text-2xl sm:text-3xl md:text-4xl text-matrix-cream leading-[1.2] mb-3 md:mb-4 drop-shadow-[0_0_16px_rgba(245,230,200,0.15)]" data-id="element-48">
            Cuaderno de Reflexión:{' '}
            <span className="italic" style={{
            color: GOLD
          }} data-id="element-49">
              Despierta el Juego
            </span>
          </h2>
          <p className="font-inter text-[11px] md:text-xs tracking-[0.28em] uppercase mb-6 md:mb-7" style={{
          color: 'rgba(216,184,120,0.75)'
        }} data-id="element-50">
            Workbook de aplicación de 31 páginas
          </p>

          <div className="space-y-5 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9] mb-8" data-id="element-51">
            <p data-id="element-52">
              Este workbook fue creado para acompañarte después de la lectura
              del ebook y ayudarte a aplicar sus ideas a tu propia vida.
            </p>
            <p data-id="element-53">
              A través de preguntas profundas, ejercicios de escritura
              consciente y espacios de reflexión, podrás observar tus patrones,
              cuestionar creencias heredadas y mirar tus decisiones desde una
              nueva perspectiva.
            </p>
          </div>

          {/* Exercises */}
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-2.5 mb-9" data-id="element-54">
            {EXERCISES.map(ex => <li key={ex} className="flex items-center gap-2.5 text-sm md:text-[15px] text-matrix-white/85 font-light" data-id="element-55">
                <span className="h-1.5 w-1.5 shrink-0 rounded-full" style={{
              backgroundColor: GOLD
            }} data-id="element-56"></span>
                {ex}
              </li>)}
          </ul>

          {/* Value line */}
          <div className="mb-8 border-l-2 pl-5" style={{
          borderColor: 'rgba(216,184,120,0.6)'
        }} data-id="element-57">
            <p className="font-cinzel text-base md:text-lg text-matrix-cream" data-id="element-58">
              Valor individual del bono:{' '}
              <span style={{
              color: GOLD
            }} data-id="element-59">
                $17
              </span>
            </p>
            <p className="font-inter text-sm text-matrix-white/70 font-light mt-1" data-id="element-60">
              Incluido hoy con tu compra.
            </p>
          </div>

          <motion.a href="#precio" onClick={scrollToPrecio} whileHover={{
          scale: 1.03,
          boxShadow: '0 0 34px rgba(216,184,120,0.5)'
        }} whileTap={{
          scale: 0.97
        }} style={{
          backgroundImage: 'linear-gradient(135deg, #e8cf9a 0%, #d8b878 50%, #c4a05f 100%)',
          color: '#0a0f0a'
        }} className="inline-block w-full sm:w-auto text-center whitespace-nowrap font-inter font-bold text-sm md:text-base px-8 md:px-12 py-3.5 md:py-4 rounded-md uppercase tracking-[0.08em] transition-all duration-300 shadow-[0_0_28px_rgba(216,184,120,0.4)] border border-[rgba(255,245,220,0.4)] cursor-pointer outline-none" data-id="element-61">
            QUIERO MI EBOOK + BONO
          </motion.a>
        </motion.div>
      </div>
    </section>;
}